/**
 * Admin 기능 토글 — 라우트 admin.features.* 와 동기화.
 *
 * index(): 페이지 내 모든 .admin-toggle-switch-form (bool) / .admin-segmented-control-form (enum) 에
 *          핸들러를 바인딩. 이후 토글 클릭은 fetch 기반 비동기로 처리되어 페이지 새로고침 없이
 *          상태가 반영된다.
 *
 * 뷰: resources/views/admin/pages/features/index.php
 * PHP 컨트롤러: app/Controllers/Admin/AdminFeatureController.php
 * 서버 응답:
 *   - bool: { result, msg, enabled } (POST /console/features/{key}/toggle)
 *   - enum: { result, msg, value }   (PATCH /console/features/{key}/mode)
 */

import { ToggleSwitchHandler } from "../components/ToggleSwitchHandler";
import { SegmentedControlHandler } from "../components/SegmentedControlHandler";
import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminFeatureController";

export const AdminFeatureController = {
  index(): void {
    const root = document.querySelector<HTMLElement>(".admin-features");
    if (!root) {
      Logger.debug(`${CTRL_TAG}.index: .admin-features not found`);
      return;
    }
    ToggleSwitchHandler.init(root);
    SegmentedControlHandler.init(root);
    Logger.debug(`${CTRL_TAG}.index: toggle + segmented handlers ready`);
  },
};
